import { render, staticRenderFns } from "./SaveBar.vue?vue&type=template&id=a9c1e754&"
import script from "./SaveBar.vue?vue&type=script&lang=ts&"
export * from "./SaveBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9c1e754')) {
      api.createRecord('a9c1e754', component.options)
    } else {
      api.reload('a9c1e754', component.options)
    }
    module.hot.accept("./SaveBar.vue?vue&type=template&id=a9c1e754&", function () {
      api.rerender('a9c1e754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SaveBar.vue"
export default component.exports